import * as _ from 'underscore'
import * as moment from 'moment'

import { BasicParameter } from '../../../common/parameters/extensions'
import { ErrorRowItem, ErrorsSummaryResult, SummaryOptions } from '../'
import { Enums } from '../../../../models/common'
import { ColumnModel } from '../../../api/api.models'

import { LocalizationHelper } from '../../../../helpers'

// #region Public Types
export const SERVICE_NAME: string = 'IMRErrorsSummaryService'
// #endregion

export class ErrorsSummaryService {

    // #region Consts
    private static get DEFAULT_ERROR_MARKER(): string { return '*' }
    private static get DURATION_FORMAT(): string { return 'mm:ss.SSS' }
    // #endregion

    private parseErrorsDescription(descr: string, errorMarker: string = ErrorsSummaryService.DEFAULT_ERROR_MARKER): string[] {
        const errorsArray: string[] = descr.split('\n')
        return errorsArray.filter((error: string) => {
            return error.indexOf(errorMarker) !== -1
        })
    }

    public getErrorsSummaryParameters(summaryOptions: SummaryOptions): BasicParameter[] {

        const parameters: BasicParameter[] = []

        if (summaryOptions != null) {
            if (summaryOptions.duration != null) {
                const durationParameter: BasicParameter = {
                    caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Duration),
                    unit: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DurationFormat)
                }

                durationParameter.value = moment(summaryOptions.duration).format(ErrorsSummaryService.DURATION_FORMAT)

                parameters.push(durationParameter)
            }
            
            if (summaryOptions.parameters != null) {
                parameters.push(...summaryOptions.parameters)
            }
        }

        return parameters  
    }

    public getErrorsSummaryGridColumns(): ColumnModel[] {
        const columns: ColumnModel[] = []

        const occurrencesColumn: ColumnModel = new ColumnModel()
        occurrencesColumn.idName = 'occurrences'
        occurrencesColumn.name = 'Occurrences'
        occurrencesColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Occurrences)
        occurrencesColumn.type = Enums.DataTypeClass.Integer
        columns.push(occurrencesColumn)

        const nameColumn: ColumnModel = new ColumnModel()
        nameColumn.idName = 'name'
        nameColumn.name = 'Name'
        nameColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name)
        nameColumn.type = Enums.DataTypeClass.Text
        columns.push(nameColumn)

        const statusColumn: ColumnModel = new ColumnModel()
        statusColumn.idName = 'status'
        statusColumn.name = 'Status'
        statusColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Status)
        statusColumn.type = Enums.DataTypeClass.Text
        columns.push(statusColumn)

        return columns
    }

    public createSelectedErrorsArray(selectedRows: ErrorRowItem[]): number[] {
        const rowKeysToLeave: number[] = []

        if (selectedRows != null) {
            selectedRows.forEach((row: ErrorRowItem) => {
                if (row.mainGridKeys && row.mainGridKeys != null) {
                    row.mainGridKeys.forEach((key: number) => {
                        if (_.indexOf(rowKeysToLeave, key) === -1) {
                            rowKeysToLeave.push(key)
                        }
                    })
                }
            })
        }

        return rowKeysToLeave
    }

    public createErrorsDataset(summaryResult: ErrorsSummaryResult[], errorMarker: string): ErrorRowItem[] {
        const items: ErrorRowItem[] = []

        if (summaryResult != null) {
            summaryResult.forEach((result: ErrorsSummaryResult) => {
                if (result.isVisible) {
                    const errorsArray: string[] = this.parseErrorsDescription(result.description, errorMarker)
                    if (errorsArray != null) {
                        errorsArray.forEach((error: string) => {
                            const errorExist: boolean = items.some((item: ErrorRowItem) => {
                                if (item.name === error) {
                                    item.occurrences = ++item.occurrences
                                    item.mainGridKeys.push(result.key)
                                    return true
                                }
                            })

                            if (!errorExist) {
                                const item: ErrorRowItem = new ErrorRowItem()
                                item.occurrences = 1
                                item.name = error
                                item.status = result.status
                                item.id = items.length
                                item.mainGridKeys = [result.key]
                                items.push(item)
                            }
                        })
                    }
                }
            })
        }

        return items
    }

}